"use client";

import Link from "next/link";

import {
  buildEcommerceEvent,
  createEcommercePayload,
  mapProductToItem,
  mapProductTypeToAnalyticsCategory,
} from "@/lib/analytics/ecommerce-analytics";
import { setItemListOrigin } from "@/lib/analytics/item-list-context";

import { EVENTS } from "@/constants/analytics.constants";
import { useTagging } from "@/hooks/useTagging";

export function FeaturedKitLink({
  href,
  pkg,
  index,
  pageName = "blu_homepage_featured_kits",
  children,
  className,
}: FeaturedKitLinkProps) {
  const [, setTag] = useTagging();

  const handleClick = () => {
    const itemListId = pageName;
    const itemListName = "featured_kits";
    const product = pkg.product;

    setItemListOrigin({
      item_list_id: itemListId,
      item_list_name: itemListName,
      item_id: product?.id ?? undefined,
      item_slug: product?.slug ?? undefined,
    });

    const item = mapProductToItem(
      {
        id: product?.id ?? undefined,
        slug: product?.slug ?? undefined,
        name: product?.name ?? undefined,
        listPrice: product?.listPrice,
        salesPrice: product?.salesPrice,
        type: product?.type,
      },
      {
        index,
        category: mapProductTypeToAnalyticsCategory(product?.type, product?.id),
      },
    );

    const payload = createEcommercePayload([item], {
      item_list_id: itemListId,
      item_list_name: itemListName,
    });

    setTag(buildEcommerceEvent(EVENTS.SELECT_ITEM, payload), { reset: true });
  };

  return (
    <Link href={href} className={className} onClick={handleClick}>
      {children}
    </Link>
  );
}

type FeaturedKitLinkProps = {
  href: string;
  pkg: {
    product?: {
      id?: string | null;
      slug?: string | null;
      name?: string | null;
      listPrice?: number | null;
      salesPrice?: number | null;
      type?: string | null;
    } | null;
  };
  index: number;
  pageName?: string;
  children: React.ReactNode;
  className?: string;
};
